<template>
  <div>
    <b-card no-body class="my-2">
      <b-card-header class="card-header-results border-0">
        <b-button
          v-b-tooltip.hover.top :title=" collapsed ? $gettext('less') :$gettext('more')"
          variant="primary"
          size="sm">
          <b-icon
            @click="toggleCollapse()"
            :icon="collapsed ? 'dash' : 'plus'"
            />
        </b-button>
        <div style="max-width:20rem;"
          class="card-header-result-name mr-auto ml-2"
          @click="toggleCollapse()">
          <span style="font-size:14px;" v-show="!collapsed">
            <strong class="mr-2">{{result.name}}</strong>
            <sup class="text-warning" v-if="starsIsNumber">
              <span v-for="star in result.stars" :key="'stars' + star">
                <b-icon icon="star-fill" />
              </span>
            </sup>
            <h6 class="text-primary d-inline ml-2">
              <small v-if="!starsIsNumber">{{result.stars}}</small>
              <small>{{result.extraStars}}</small>
            </h6>
          </span>
        </div>
        <div class="mr-2 text-center">
          <small class="text-primary">
            {{mealLabel}}
          </small>
        </div>
        <div class="price-and-status">
          <span v-if="status =='AVL'" class="FCAVL mr-2" v-b-tooltip.hover.top :title="$gettext('Available')">{{status}}</span>
          <span v-if="status =='RQ'" class="RQNA" v-b-tooltip.hover.top :title="$gettext('On request')">{{status}}</span>
          <span v-if="status =='N/A'" class="SPOEBD" v-b-tooltip.hover.top :title="$gettext('On request')">RQ</span>
          <span class="price-start-at">
            <small><translate>from</translate>:</small> <span :class="displayedMeal.discount ? 'line-through':' '">{{ getFullPrice({ meal: displayedMeal, starRating: result.stars, fees }) }} {{ params.currency }}</span>
          </span>
          <span class="price-off" v-if="displayedMeal.discount">
            <small><translate>sale</translate>:</small> {{ getPrice({ meal: displayedMeal, starRating: result.stars, fees }) }} {{ params.currency }}
          </span>
        </div>
        <div>
          <b-button
          :variant="selected || collapsed ? 'success' : 'outline-info'"
          @click="$emit('toggle')"
          :size="!collapsed ? 'sm' : ''"
          >
          <b-iconstack>
            <b-icon icon="square" scale="0.8" stacked />
            <b-icon icon="check" v-if="selected" scale="0.7" stacked />
          </b-iconstack>
          PDF
        </b-button>
        <b-button
          :variant="collapsed ? 'success' : 'info'"
          @click="$emit('info')"
          :size="!collapsed ? 'sm' : ''"
          class="mx-2">
          <b-icon icon="info-circle-fill" />
        </b-button>
        </div>
      </b-card-header>
      <b-card-body v-if="collapsed" class="bg-light">
        <b-row>
          <b-col md="4" class="d-flex align-items-center">
            <b-card no-body class="bg-light mb-4 mb-sm-0 border-0 shadow-sm">
              <b-carousel
                id="carousel"
                controls
                indicators
                v-if="result.images.length"
                v-b-tooltip.hover.left :title="$gettext('Click to see enlarged images')"
                class="pointer"
              >
                <b-carousel-slide v-for="(image,imageIndex) in result.images" :key="'img' + imageIndex">
                  <template slot="img">
                    <img :src="image.url" class="img-fluid w-100 d-block carousel-img" @click="open"/>
                  </template>
                </b-carousel-slide>
              </b-carousel>
              <template v-else>
                <img v-if="result.image" :src="result.image.url" class="img-fluid" />
                <img v-else src="@/assets/images/backgrounds/default-image.jpg" class="img-fluid" />
              </template>
              <b-card-text class="justify-content-center d-flex flex-column">
              <div class="d-flex justify-content-around result-summary p-2">
              <span><span class="mr-1"><b v-translate>Destination:</b> </span>{{ params.resortName }}</span>
            </div>
            </b-card-text>
            </b-card>
          </b-col>
          <b-col md="8">
            <h5 class="text-left d-inline">
              <span class="mr-2">{{result.name}}</span>
               <sup class="text-warning" v-if="starsIsNumber">
                <span v-for="star in result.stars" :key="'stars' + star">
                  <b-icon icon="star-fill" />
                </span>
              </sup>
            </h5>
            <h6 class="text-primary d-inline ml-2">
              <small v-if="!starsIsNumber">{{result.stars}}</small>
              <small>{{result.extraStars}}</small>
            </h6>
            <p v-if="result.descriptionIsHtml" v-html="result.description"></p>
            <p style="white-space: pre-line;" v-else>{{ result.description }}</p>
            <span v-if="result.url">
              <hr class="my-1">
              <p class="my-1">
                <a :href="result.url" target="_blank">{{ result.url }}</a>
              </p>
            </span>
          </b-col>
          <b-col sm="12">
            <div class="d-flex flex-wrap">
              <span v-for="amenityIcon in amenitiesIcons" :key="amenityIcon.id">
                <i :class="amenityIcon.class" v-b-tooltip.hover :title="amenityIcon.label" class="ico-btn"></i>
              </span>
            </div>
          </b-col>
        </b-row>
        <slot></slot>
      </b-card-body>
    </b-card>
    <b-modal v-model="modal" title="Modal Info" size="xl" hide-header hide-footer centered id="lightbox">
      <b-row>
        <b-col class="mx-auto" md="8">
          <div class="d-flex justify-content-end mb-3">
            <b-button class="btn btn-primary btn-sm btn-lightbox" @click="close" v-b-tooltip.hover :title="$gettext('Close')">
              <b-icon icon="x" />
            </b-button>
          </div>
          <b-card no-body>
              <b-carousel
                id="popupCarousel"
                controls
                indicators
                background="#FFF"
                v-if="result.images.length"
              >
                <b-carousel-slide v-for="(image,imageIndex) in result.images" :key="'popupImage' + imageIndex">
                  <template slot="img">
                    <img :src="image.url" class="img-fluid w-100 d-block carousel-img"/>
                  </template>
                </b-carousel-slide>
              </b-carousel>
              <template v-else>
                <img v-if="result.image" :src="result.image.url" class="img-fluid" />
                <img v-else src="@/assets/images/backgrounds/default-image.jpg" class="img-fluid" />
              </template>
            </b-card>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import { getFullPrice, getPrice } from 'b2b-common/utils/hotel'
import { customIcons } from '../../../../shared/utils'

export default {
  name: 'SearchResult',
  props: {
    params: Object,
    result: Object,
    selected: Boolean,
    expanded: Boolean,
    displayedMeal: Object,
    fees: {
      type: Object,
      required: false,
      default: () => { return {} }
    }
  },
  data () {
    return {
      collapsed: this.expanded,
      modal: false,
      icons: customIcons
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    },
    getFullPrice,
    getPrice,
    close () {
      this.modal = false
    },
    open () {
      this.modal = true
    }
  },
  computed: {
    starsIsNumber () {
      return typeof this.result.stars === 'number'
    },
    amenitiesIcons () {
      if (!this.result.hotel_amenities || !this.result.hotel_amenities.length) return []
      return this.icons.filter(icon => this.result.hotel_amenities.some(el => el.id === icon.id))
    },
    mealLabel () {
      if (this.result.isInhouse) return this.result.packages[0].categories[0].meals[0].label
      else return ''
    },
    status () {
      let isAvl = false
      let isNa = true

      const categoriesMap = data => {
        data.categories.map(cat => {
          if (cat.hotelIsAvailable && !cat.hotelIsBlackedOut) isAvl = true
          if (!cat.hotelIsBlackedOut) isNa = false
        })
      }

      if (this.result.packages) {
        this.result.packages.map(pack => {
          categoriesMap(pack)
        })
      } else {
        categoriesMap(this.result)
      }

      if (isAvl) return 'AVL'
      else if (isNa) return 'N/A'
      else return 'RQ'
    }
  }
}
</script>

<style lang="css">
  #lightbox .modal-content,
  #lightbox .modal-content .card {
    background:rgba(255,25,255,0);
    border: none;
  }
  .btn-lightbox{
    border:2px solid #fff;
  }
  .line-through{
    text-decoration: line-through;
  }
  .ico-btn{
    font-size: 2rem;
    border: 1px solid #0095ab;
    padding: 3px;
    border-radius: 5px;
    margin: 3px;
    color: #0095ab;
  }
</style>
